import { businessCell, isIsoDateCell } from '@/frontend/features/Fde/investigations/businessCasePresentation'
import type { BusinessEvidenceView, InvestigationLabels } from '@/frontend/features/Fde/investigations/types'

interface Props { row: Record<string, unknown>; columns: BusinessEvidenceView['columns']; copy: InvestigationLabels }

/** A record is projected exactly as supplied: no promoted heading, dropped
 * columns, derived quantities or implied importance of this position.
 */
export default function EvidenceRecord({ row, columns, copy }: Props) {
  return <dl className="grid min-w-0 gap-x-6 gap-y-4 sm:grid-cols-2 xl:grid-cols-3">
    {columns.map((column) => <div key={column.field} className="grid min-w-0 content-start gap-1">
      <dt className="text-xs leading-relaxed text-muted-foreground">{column.label}</dt>
      <dd className={`min-w-0 text-sm leading-relaxed tabular-nums ${isIsoDateCell(row[column.field]) ? 'overflow-x-auto whitespace-nowrap' : 'whitespace-pre-wrap break-words'}`}>
        {businessCell(row[column.field], copy.business_value_missing, copy.business_list_empty)}
      </dd>
    </div>)}
  </dl>
}
